// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__sqo5M","header":"MergedInvoice_header__1LTr5"};